import { render, staticRenderFns } from "./ShipmentItemProductForm.vue?vue&type=template&id=5ac89e51&scoped=true&lang=pug"
import script from "./ShipmentItemProductForm.vue?vue&type=script&lang=js"
export * from "./ShipmentItemProductForm.vue?vue&type=script&lang=js"
import style0 from "./ShipmentItemProductForm.vue?vue&type=style&index=0&id=5ac89e51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac89e51",
  null
  
)

export default component.exports